module.exports = __webpack_public_path__ + "img/logo.d6e15cf9.webp";